import SvgIcon from '@material-ui/core/SvgIcon';

const PillIcon = ({
  fillColor,
  className,
}: {
  fillColor?: string;
  className?: string;
}) => {
  return (
    <SvgIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="8" cy="8" r="6" fill={fillColor}></circle>
    </SvgIcon>
  );
};

export default PillIcon;
